import {
  BuscadorEstudioBody,
  BuscadorEstudioCarouselBtnContainer,
  BuscadorEstudioContainer,
  BuscadorEstudioCurva,
  BuscadorEstudioFooter,
  BuscadorEstudioHeader,
  BuscadorEstudioTecladoContainer,
} from "./localStyle";
import { useContext, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { quitarTildes } from "global/utils/quitarTildes";
import { showToaster } from "global/context/action/toaster/toaster";
import { GlobalContext } from "global/context/Provider";
import { hideModal, showModal } from "global/context/action/modal/modal";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import TecladoAlfanumerico from "_+_Portal/components/Genericos/TecladoAlfanumerico/TecladoAlfanumerico";
import BarraBlanca from "_+_Portal/_-_Autocheckin/components/genericos/BarraBlanca/BarraBlanca";
import InputBuscador from "_+_Portal/_-_Autocheckin/components/genericos/InputBuscador/InputBuscador";
import { PortalContext } from "_+_Portal/context/Provider";
import {
  wsGetVerificaEstudiosQr,
  wsPostCalulaMinutos,
  wsPostTurnosEstudiosQr,
} from "_+_Portal/context/Actions/turnos/estudioTurnos";
import Carousel from "_+_Portal/_-_Autocheckin/components/genericos/Carousel/Carousel";
import { setNuevoTurno } from "_+_Portal/context/Actions/nuevoTurno/nuevoTurno";
import ModalVerificaOs from "_+_Portal/_-_Autocheckin/components/genericos/ModalVerificaOs/ModalVerificaOs";
import { wsGetDatosBioseguridad } from "_+_Portal/context/Actions/paciente/paciente";
import CircuitoReso from "_+_Portal/components/Genericos/Preguntas/CircuitoReso2";
import CircuitoTomo from "_+_Portal/components/Genericos/Preguntas/CircuitoTomo2";
import {
  createDtoBusquedaEstudiosDisponibles,
  createDtoCalculaMinutos,
} from "./dtoBusquedaEstudiosDisponibles";
import ModalPreparacion from "_+_Portal/_-_Autocheckin/components/genericos/ModalPreparacion/ModalPreparacion";
import Modal from "global/component/Genericos/Modal/Modal";
import { editaTurnosDisponibles } from "_+_Portal/context/Actions/turnos/turnosDisponibles";
import { estudioGrupo } from "_+_Portal/context/Actions/estudioGrupo/estudioGrupo";

const BuscadorTurnoEstudio = () => {
  //#region --------- context ---------------
  const { authState, toasterDispatch, modalState, modalDispatch } =
    useContext(GlobalContext);
  const {
    estudioTurnosDispatch,
    nuevoTurnoState,
    nuevoTurnoDispatch,
    estudioGrupoState,
    estudioGrupoDispatch,
    turnosDisponiblesState,
    turnosDisponiblesDispatch,
    pacienteDispatch,
  } = useContext(PortalContext);
  //#endregion  ----- context ---------------
  //#region  ----------- constants ---------------
  const [busquedaStr, setBusquedaStr] = useState("");
  const [prestacionesAgregadas, setPrestacionesAgregadas] = useState([]);
  const [isMounted, setIsMounted] = useState(true);
  const [filteredData, setFilteredData] = useState();
  const [prestacionesInicial, setPrestacionesInicial] = useState();
  let nuevoArrayPrestaciones = [...prestacionesAgregadas];
  const [loading, setLoading] = useState(true);
  const [loadingPaciente, setLoadingPaciente] = useState(false);
  const [filtroCircuito, setFiltroCircuito] = useState("");
  const maxLength = 25;
  const history = useHistory();
  const minimize = prestacionesAgregadas.length > 0;
  const pacienteSeleccionado = nuevoTurnoState.nuevoTurno.familiar?.paciente;
  const location = useLocation();
  const rutaActual = location.pathname.replace("/autoterminalDesktop/", "");

  let prestacionesSeleccionada = null;
  // let opcTurnoKin = configTerminalState.configTerminal?.opcTurnoKin;
  let opcTurnoKin = true;
  let isKinesio = false;
  const dtoVerificaOs = {
    especialidad: null,
    fechaDesde: null,
    medico: null,
    particular: false,
    idPacFamiliar: -1,
    osAlternativa: false,
    grupoMedico: false,
    flgVideoAtencion: nuevoTurnoState.nuevoTurno.videoAtencion,
    concontraste: false,
  };

  let dtoPreguntas = {
    peso: false,
    contraste: false,
    renal: false,
    contrasteReciente: false,
    embarazo: false,
    amamantando: false,
    marcapasos: false,
    bioseguridadDTO: {
      flgConContraste: false,
      flgDiabetico: false,
      flgHipertenso: false,
      flgInsuficienciaRenal: false,
      flgLabFuncionRenal: false,
      flgMarcapasos: false,
      flgImplanteMetalico: false,
      materialImpMet: "",
      ubicacionImpMet: "",
      fechaImpMet: "0001-01-01",
      marcaMarcapasos: "",
      modeloMarcapasos: "",
      fechaMarcapasos: "0001-01-01",
    },
  };

  const idCircuitoMensajesList = [1, 3, 5, 6, 7, 8];
  const idCircuitoParticular = [9];
  const idCircuitoOsAlternativa = [91];
  const idCircuitoSinTurnoPrevio = [10];

  //#endregion --------- constants ---------------
  //#region  ----------- funciones ---------------

  const obtenerFechaActual = () => {
    const hoy = new Date();
    const año = hoy.getFullYear();
    const mes = String(hoy.getMonth() + 1).padStart(2, "0");
    const dia = String(hoy.getDate()).padStart(2, "0");
    return `${año}-${mes}-${dia}`;
  };

  const onEnterBuscar = () => {
    if (prestacionesAgregadas.length > 0) {
      if (filtroCircuito === "ESTET") {
        onClickBuscar();
      } else {
        setLoadingPaciente(true);
        wsGetDatosBioseguridad((isCorrect, data) => {
          if (isCorrect) {
            if (filtroCircuito === "RMN") {
              showModal(
                <CircuitoReso
                  texto={
                    " Porfavor, complete los siguientes datos para buscarle turnos"
                  }
                  dissmiss={dismiss}
                  dataBioseguridad={data}
                  onClickBuscar={onClickBuscar}
                />,
                "Datos necesarios",
                dismiss,
                false,
                [],
                "centro",
                true,
              )(modalDispatch);
            } else {
              showModal(
                <CircuitoTomo
                  texto={
                    " Porfavor, complete los siguientes datos para buscarle turnos"
                  }
                  dissmiss={dismiss}
                  dataBioseguridad={data}
                  onClickBuscar={onClickBuscar}
                />,
                "Datos necesarios",
                dismiss,
                false,
                [],
                "centro",
                true,
              )(modalDispatch);
            }
          } else {
            showModal(
              "Genericos/Mensaje/Mensaje",
              {
                titulo: "Atención",
                textoNegrita: (
                  <span className="rb18l">
                    {data.data
                      ? data.data
                      : "Error al obtener datos de bioseguridad del paciente"}
                  </span>
                ),
                dissmiss: dismiss,
                danger: true,
              },
              [
                {
                  text: "Cerrar",
                  clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
                  accion: dismiss,
                },
              ],
              "centro",
              true,
            )(modalDispatch);
          }
          setLoadingPaciente(false);
        })(pacienteDispatch);
      }
    } else {
      showToaster(
        {
          texto: "Debe seleccionar una opción",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
    }
  };

  const onClickBuscar = (preguntas) => {
    dtoPreguntas = preguntas;
    setLoading(true);
    hideModal()(modalDispatch);
    const dtoCalculaMinutos = createDtoCalculaMinutos({
      gruposMedico: prestacionesAgregadas,
      familiar: pacienteSeleccionado,
      conContraste: preguntas?.contraste,
    });
    wsPostCalulaMinutos(
      dtoCalculaMinutos,
      nextStepCalculaMinutos,
    )(estudioTurnosDispatch);
  };

  const nextStepCalculaMinutos = (isCorrect, resp) => {
    if (isCorrect) {
      buscarTurnosDisponibles(resp);
    }
  };

  const onChangeTeclado = (value) => {
    if (value) {
      filtrarData(value);
    } else {
      setBusquedaStr("");
    }
  };

  const onDeleteTeclado = () => {
    setNuevoTurno({ seleccionMasSolicitado: null })(nuevoTurnoDispatch);
    filtrarData("");
    if (!prestacionesAgregadas.length > 0) {
      sortedDataDefault();
    } else {
      sortedDataDefault(filtroCircuito);
    }
  };

  const filtrarData = (value) => {
    setBusquedaStr(value);
    const searchWords = value
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .split(" ");

    const filtered = filteredData?.filter((item) => {
      const tagField = item["tags"]
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");

      const descriptionField = item["descripcion"]
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");

      return searchWords.every(
        (word) => tagField.includes(word) || descriptionField.includes(word),
      );
    });

    setFilteredData(filtered);
  };

  const textMisTurnos =
    "Recuerde que puede tomar un turno desde nuestro portal. También puede hacer la fila y atenderse en el centro";

  const onClickAgregarPrestacion = (prestacion) => {
    if (prestacion.idCircuito === "KIN") {
      isKinesio = true;
      // setRutas({ isKinesio: true })(rutaDispatch);
      // if (!opcTurnoKin) {
      //   showModal(
      //     <ModalTurnosMobile dissmiss={dismiss} />,
      //     textMisTurnos,
      //     dismiss,
      //     false,
      //     {},
      //     "centro",
      //     true,
      //   )(modalDispatch);
      // } else {
      setLoading(true);
      const { codigo, id } = nuevoTurnoState.nuevoTurno.familiar;
      dtoVerificaOs.grupoMedico = {
        Id: prestacion.id,
        Descripcion: prestacion.descripcion,
        Particular: dtoVerificaOs.particular,
      };
      dtoVerificaOs.idPacFamiliar = codigo === 0 ? -1 : id;
      prestacionesSeleccionada = dtoVerificaOs.grupoMedico;
      setNuevoTurno({
        dtoBusqueda: {
          GruposMedico: [dtoVerificaOs.grupoMedico],
        },
      })(nuevoTurnoDispatch);
      wsGetVerificaEstudiosQr(
        prestacion.id,
        dtoVerificaOs.particular,
        false,
        false,
        false,
        nextStepVerificaOs,
      )(estudioTurnosDispatch);
      // }
    } else {
      isKinesio = false;
      // setRutas({ isKinesio: false })(rutaDispatch);
      dtoVerificaOs.grupoMedico = {
        Id: prestacion.id,
        Descripcion: prestacion.descripcion,
        Particular: dtoVerificaOs.particular,
      };
      const objetoEncontrado = prestacionesAgregadas.find(
        (item) => item.Id === dtoVerificaOs.grupoMedico.Id,
      );
      if (!objetoEncontrado) {
        setLoading(true);
        // Reset de data antes de buscar nuevamente
        dtoVerificaOs.particular = false;
        dtoVerificaOs.osAlternativa = false;
        setNuevoTurno({
          osAlternativa: false,
        })(nuevoTurnoDispatch);
        setNuevoTurno({ dtoBusqueda: null })(nuevoTurnoDispatch);
        const { codigo, id } = nuevoTurnoState.nuevoTurno.familiar;
        dtoVerificaOs.idPacFamiliar = codigo === 0 ? -1 : id;
        dtoVerificaOs.medico = prestacion.medico;
        dtoVerificaOs.especialidad = prestacion.especialidad;
        dtoVerificaOs.fechaDesde = obtenerFechaActual();
        dtoVerificaOs.concontraste = prestacion.conContraste;
        dtoVerificaOs.circuito = prestacion.idCircuito;
        prestacionesSeleccionada = dtoVerificaOs.grupoMedico;
        wsGetVerificaEstudiosQr(
          prestacion.id,
          dtoVerificaOs.particular,
          false,
          false,
          false,
          nextStepVerificaOs,
        )(estudioTurnosDispatch);
      } else {
        showToaster(
          {
            texto: "La prestación ya fue agregada",
            tipo: "danger",
          },
          "centroArriba",
        )(toasterDispatch);
      }
    }
  };

  const onClickEliminarPrestacion = (prestacionEliminar) => {
    const nuevoArrayPrestaciones = prestacionesAgregadas.filter(
      (item) => item !== prestacionEliminar,
    );
    setPrestacionesAgregadas(nuevoArrayPrestaciones);
    if (nuevoArrayPrestaciones.length < 1) {
      setFiltroCircuito("");
      if (busquedaStr !== "") {
        sortedDataBusquedaSrt(busquedaStr);
      } else {
        sortedDataDefault();
      }
    }
  };

  const nextStepVerificaOs = (isCorrect, data) => {
    if (isCorrect) {
      nuevoArrayPrestaciones = [
        ...prestacionesAgregadas,
        prestacionesSeleccionada,
      ];

      if (data.calcularMinutos) {
        setLoading(false);
        handleRemount();
        setFiltroCircuito(data.circuito);
        let arrGrupoMedico = (
          estudioGrupoState.estudioGrupo?.data ?? []
        ).filter((item) => {
          return item.idCircuito === data.circuito;
        });
        const sortedData = arrGrupoMedico.sort((a, b) => {
          if (a.cantBusquedas > b.cantBusquedas) return -1;
          if (a.cantBusquedas < b.cantBusquedas) return 1;
          return 0;
        });

        setFilteredData(sortedData);
        setPrestacionesAgregadas(nuevoArrayPrestaciones);
        if (data.preparacion !== "" || data.requiereAutorizacion) {
          showModal(
            <ModalPreparacion
              prestacion={prestacionesSeleccionada}
              data={data}
              dismiss={dismiss}
              fullStr={true}
            />,
            data.preparacion === "" && data.requiereAutorizacion
              ? "Autorización"
              : "Preparaciones",
            dismiss,
            false,
            [],
            "centro",
            true,
          )(modalDispatch);
        }
      } else {
        if (data.preparacion !== "" || data.requiereAutorizacion) {
          setLoading(false);
          showModal(
            <ModalPreparacion
              fullStr={true}
              prestacion={prestacionesSeleccionada}
              data={data}
              buscar={true}
              onClickBuscar={dismissPreparacion}
              dismiss={dismiss}
            />,
            data.preparacion === "" && data.requiereAutorizacion
              ? "Autorización"
              : "Preparaciones",
            () => {},
            false,
            [],
            "centro",
            true,
          )(modalDispatch);
        } else {
          buscarTurnosDisponibles();
        }
      }
    } else {
      //IS CORRECT ES ERROR
      if (
        idCircuitoMensajesList.includes(data?.detail?.codigo) &&
        !data?.detail?.continua
      ) {
        setLoading(false);
        return showToaster(
          {
            texto: data.mensaje,
            tipo: "danger",
          },
          "centroArriba",
        )(toasterDispatch);
      } else if (
        idCircuitoParticular.includes(data?.detail?.codigo) &&
        !data?.detail?.continua
      ) {
        setLoading(false);
        return showModal(
          <ModalVerificaOs
            data={data}
            fullStr={true}
            prestacion={prestacionesSeleccionada}
            btnAceptarStr={"Tomar como particular"}
            onClickCancelar={dismiss}
            onClick={() =>
              onClickTomarComoParticular(data, nuevoArrayPrestaciones)
            }
          />,
          "Atención",
          dismiss,
          false,
          [],
          "centro",
          true,
        )(modalDispatch);
      } else if (
        idCircuitoOsAlternativa.includes(data?.detail?.codigo) &&
        !data?.detail?.continua
      ) {
        setLoading(false);
        return showModal(
          <ModalVerificaOs
            data={data}
            fullStr={true}
            prestacion={prestacionesSeleccionada}
            btnAceptarStr={"Tomar con OS alternativa"}
            onClick={onClickTomarConOsAlternativa}
            onClickCancelar={dismissOsAlternativa}
          />,
          "Atención",
          dismiss,
          false,
          [],
          "centro",
          true,
        )(modalDispatch);
      } else if (idCircuitoSinTurnoPrevio.includes(data?.detail?.codigo)) {
        setLoading(false);
        return showModal(
          <ModalVerificaOs
            data={data}
            btnAceptarStr={"Ir a menú principal"}
            onClick={onClickSinTurnoPrevio}
            onClickCancelar={dismiss}
          />,
          "Atención",
          dismiss,
          false,
          [],
          "centro",
          true,
        )(modalDispatch);
      } else {
        setLoading(false);
        showToaster(
          {
            texto: data?.mensaje ? data?.mensaje : "Ha ocurrido un error",
            tipo: "danger",
          },
          "centroArriba",
        )(toasterDispatch);
      }
    }
  };

  const dismissPreparacion = () => {
    setLoading(true);
    hideModal()(modalDispatch);
    if (isKinesio) {
      history.push("/diahorariokinesio");
    } else {
      buscarTurnosDisponibles();
    }
  };

  function verificarParticular(array) {
    for (let i = 0; i < array.length; i++) {
      if (array[i].particular === true || array[i].Particular === true) {
        return true;
      }
    }
    return false;
  }

  const buscarTurnosDisponibles = (calculaMinutos) => {
    let flgParticular = false;
    let idGrupoMedico = 0;
    let gruposMedicos = [];
    let minutosGrupo = 0;
    if (calculaMinutos?.data?.length > 0) {
      flgParticular = verificarParticular(calculaMinutos.data);
      idGrupoMedico = calculaMinutos.data[0]?.id;
      gruposMedicos = calculaMinutos.data;
      minutosGrupo = calculaMinutos.minutos;
    } else {
      flgParticular = verificarParticular(nuevoArrayPrestaciones);
      idGrupoMedico = nuevoArrayPrestaciones[0]?.Id;
      gruposMedicos = nuevoArrayPrestaciones;
    }
    let dtoPost = createDtoBusquedaEstudiosDisponibles({
      circuito: filtroCircuito,
      amamantando: dtoPreguntas?.amamantando
        ? dtoPreguntas?.amamantando
        : false,
      conContraste: dtoPreguntas?.contraste,
      contrasteReciente: dtoPreguntas?.contrasteReciente
        ? dtoPreguntas?.contrasteReciente
        : false,
      diabeticoHipertenso: false,
      embarazada: dtoPreguntas?.embarazo ? dtoPreguntas?.embarazo : false,
      familiar: nuevoTurnoState.nuevoTurno.familiar.paciente,
      fechaDesde: obtenerFechaActual(),
      gruposMedico: gruposMedicos,
      idGrupoMedico: idGrupoMedico,
      insRenal: dtoPreguntas?.renal,
      marcapasos: dtoPreguntas?.marcaPasos,
      OsAlternativa: dtoVerificaOs.osAlternativa,
      particular: flgParticular,
      peso: dtoPreguntas?.peso,
      videoAtencion: dtoVerificaOs.flgVideoAtencion,
      minutosGrupo: minutosGrupo,
      bioseguridadDTO: {
        flgConContraste: dtoPreguntas.contraste,
        flgDiabetico: dtoPreguntas.flgDiabetico
          ? dtoPreguntas.flgDiabetico
          : false,
        flgHipertenso: dtoPreguntas.flgHipertenso
          ? dtoPreguntas.flgHipertenso
          : false,
        flgInsuficienciaRenal: dtoPreguntas.flgInsuficienciaRenal
          ? dtoPreguntas.flgInsuficienciaRenal
          : false,
        flgLabFuncionRenal: dtoPreguntas.flgLabFuncionRenal
          ? dtoPreguntas.flgLabFuncionRenal
          : false,
        flgMarcapasos: dtoPreguntas.marcaPasos
          ? dtoPreguntas.marcaPasos
          : false,
        flgImplanteMetalico: dtoPreguntas.flgImplanteMetalico
          ? dtoPreguntas.flgImplanteMetalico
          : false,
        materialImpMet: dtoPreguntas.materialImpMet
          ? dtoPreguntas.materialImpMet
          : "",
        ubicacionImpMet: dtoPreguntas.ubicacionImpMet
          ? dtoPreguntas.ubicacionImpMet
          : "",
        fechaImpMet: dtoPreguntas.fechaImpMet
          ? dtoPreguntas.fechaImpMet
          : "0001-01-01",
        marcaMarcapasos: dtoPreguntas.marcaMarcapasos
          ? dtoPreguntas.marcaMarcapasos
          : "",
        modeloMarcapasos: dtoPreguntas.modeloMarcapasos
          ? dtoPreguntas.modeloMarcapasos
          : "",
        fechaMarcapasos: dtoPreguntas.fechaMarcapasos
          ? dtoPreguntas.fechaMarcapasos
          : "0001-01-01",
      },
    });

    setNuevoTurno({ dtoBusqueda: dtoPost })(nuevoTurnoDispatch);
    wsPostTurnosEstudiosQr(dtoPost, -1, (isCorrect, data) =>
      nextStepTurnosDisponibles(isCorrect, data, dtoPost),
    )(estudioTurnosDispatch);
  };

  const nextStepTurnosDisponibles = (isCorrect, data, dtoPost) => {
    editaTurnosDisponibles({
      ...turnosDisponiblesState.turnosDisponibles.turnosData,
      turnos: data.turnos,
      GruposMedico: dtoPost.GruposMedico,
      particular: dtoPost.particular,
      idEstudio: Array.isArray(dtoPost.GruposMedico)
        ? dtoPost.GruposMedico[0].id
        : dtoPost.idGrupoMedico,
      descEstudio: Array.isArray(dtoPost.GruposMedico)
        ? dtoPost.GruposMedico[0].descripcion
          ? dtoPost.GruposMedico[0].descripcion
          : dtoPost.GruposMedico[0].Descripcion
        : dtoPost.Descripcion,
      descEspecialidad: null,
      fechaBusqueda: data.fechaBusqueda,
      // sectorTurno,
      dtoBusqueda: dtoPost,
      volverOrigen: "ESTUDIOS",
      proceso: "estudios",
      circuito: filtroCircuito,
    })(turnosDisponiblesDispatch);

    setLoading(false);
    if (isCorrect) {
      history.push(`/turnosDisponibles`);
    }
  };

  const sortedDataDefault = (filtroSeteado) => {
    const arrGrupoMed = (estudioGrupoState.estudioGrupo?.data ?? []).filter(
      (item) => {
        if (filtroSeteado) {
          return (
            item.sonPracticas === true &&
            item.id > 0 &&
            item.idCircuito === filtroSeteado
          );
        } else {
          return item.sonPracticas === true && item.id > 0;
        }
      },
    );
    const sortedData = arrGrupoMed.sort((a, b) => {
      if (a.cantBusquedas > b.cantBusquedas) return -1;
      if (a.cantBusquedas < b.cantBusquedas) return 1;
      return 0;
    });
    setPrestacionesInicial(sortedData);
    setFilteredData(sortedData);
    setLoading(false);
  };

  const sortedDataBusquedaSrt = (busqueda) => {
    const arrGrupoMed = (estudioGrupoState.estudioGrupo?.data ?? []).filter(
      (item) => {
        return item.sonPracticas === true && item.id > 0;
      },
    );
    const sortedData = arrGrupoMed.sort((a, b) => {
      if (a.cantBusquedas > b.cantBusquedas) return -1;
      if (a.cantBusquedas < b.cantBusquedas) return 1;
      return 0;
    });

    const filtered = sortedData?.filter((item) => {
      const searchWords = busqueda
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .split(" ");
      return searchWords.every((word) =>
        item["descripcion"]
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .includes(word),
      );
    });
    setPrestacionesInicial(filtered);
    setFilteredData(filtered);
  };

  const dismiss = () => {
    hideModal()(modalDispatch);
  };
  const dismissOsAlternativa = () => {
    hideModal()(modalDispatch);
    setNuevoTurno({ osAlternativa: false })(nuevoTurnoDispatch);
  };

  const onClickTomarComoParticular = () => {
    prestacionesSeleccionada.Particular = true;
    nuevoArrayPrestaciones = [
      ...prestacionesAgregadas,
      prestacionesSeleccionada,
    ];
    setLoading(true);
    dtoVerificaOs.particular = true;
    wsGetVerificaEstudiosQr(
      prestacionesSeleccionada.Id,
      dtoVerificaOs.particular,
      false,
      false,
      false,
      nextStepDobleVerificaOs,
    )(estudioTurnosDispatch);

    dismiss();
  };

  const nextStepDobleVerificaOs = (isCorrect, data) => {
    if (isCorrect) {
      if (data.calcularMinutos) {
        setLoading(false);
        handleRemount();
        setFiltroCircuito(data.circuito);
        let arrGrupoMedico = (
          estudioGrupoState.estudioGrupo?.data ?? []
        ).filter((item) => {
          return item.idCircuito === data.circuito;
        });
        const sortedData = arrGrupoMedico.sort((a, b) => {
          if (a.cantBusquedas > b.cantBusquedas) return -1;
          if (a.cantBusquedas < b.cantBusquedas) return 1;
          return 0;
        });
        setFilteredData(sortedData);
        setPrestacionesAgregadas(nuevoArrayPrestaciones);
      }
      if (data.preparacion !== "" && data.preparacion !== null) {
        setLoading(false);
        return showModal(
          <ModalPreparacion
            prestacion={prestacionesSeleccionada}
            data={data}
            dismiss={dismiss}
            fullStr={true}
            buscar={!data.calcularMinutos}
            onClickBuscar={dismissPreparacion}
          />,
          data.preparacion === "" && data.requiereAutorizacion
            ? "Autorización"
            : "Preparaciones",
          dismiss,
          false,
          [],
          "centro",
          true,
        )(modalDispatch);
      } else {
        if (isKinesio) {
          history.push("/diahorariokinesio");
        } else {
          buscarTurnosDisponibles();
        }
      }
    }
  };

  const onClickTomarConOsAlternativa = () => {
    dismiss();
    dtoVerificaOs.osAlternativa = true;
    setNuevoTurno({
      osAlternativa: true,
    })(nuevoTurnoDispatch);
    wsGetVerificaEstudiosQr(
      prestacionesSeleccionada.id,
      dtoVerificaOs.particular,
      false,
      false,
      true,
      nextStepVerificaOs,
    )(estudioTurnosDispatch);
    setLoading(true);
  };
  const onClickSinTurnoPrevio = () => {
    history.push("/home");
  };

  const handleRemount = () => {
    setIsMounted(false);
    setBusquedaStr("");
    filtrarData("");
    setTimeout(() => {
      setIsMounted(true);
    }, 100);
  };

  //#endregion --------- funciones ---------------

  //#region  ----------- useEffect ---------------

  useEffect(() => {
    setNuevoTurno({ familiar: authState.auth.data })(nuevoTurnoDispatch);
    estudioGrupo()(estudioGrupoDispatch);
  }, []);

  useEffect(() => {
    if (estudioGrupoState.estudioGrupo.data !== null) {
      sortedDataDefault();
    }
  }, [estudioGrupoState.estudioGrupo.data]);

  useEffect(() => {
    if (prestacionesInicial) {
      if (nuevoTurnoState.nuevoTurno.seleccionMasSolicitado?.descripcion) {
        filtrarData(
          quitarTildes(
            nuevoTurnoState.nuevoTurno.seleccionMasSolicitado?.descripcion,
          ),
        );
      }
    }
  }, [prestacionesInicial]);

  //#endregion  -------- useEffect ---------------

  return (
    <>
      {modalState.modal.show && <Modal />}
      <Loading
        dataLoading={loading || loadingPaciente}
        color="c-white"
        descripcion={"Cargando..."}
      />
      <BuscadorEstudioContainer>
        <BarraBlanca
          title={"Busca el turno que necesitas"}
          etiquetaBusqueda={false}
        />
        <BuscadorEstudioHeader>
          <div className="BuscadorEstudio-input-container">
            <InputBuscador value={busquedaStr} />
          </div>
        </BuscadorEstudioHeader>
        <BuscadorEstudioBody>
          {minimize && (
            <>
              {" "}
              <Carousel
                opcDelete={true}
                items={prestacionesAgregadas}
                minimize={true}
                title={"Prestaciones agregadas"}
                name={"Descripcion"}
                onClick={onClickEliminarPrestacion}
                strLabel={"PARTICULAR"}
              />
              <BuscadorEstudioCarouselBtnContainer>
                <div
                  className="BuscadorEstudio-btnAvanzar"
                  onClick={onEnterBuscar}
                >
                  Avanzar
                </div>
              </BuscadorEstudioCarouselBtnContainer>
            </>
          )}

          {filteredData && !loading && (
            <Carousel
              opcDelete={false}
              items={filteredData}
              minimize={minimize}
              title={"Resultados de búsqueda"}
              name={"descripcion"}
              onClick={(item) => onClickAgregarPrestacion(item)}
            />
          )}
        </BuscadorEstudioBody>
        <BuscadorEstudioFooter>
          <BuscadorEstudioCurva></BuscadorEstudioCurva>
          <BuscadorEstudioTecladoContainer>
            {isMounted && (
              <TecladoAlfanumerico
                sinNumeros={true}
                modeLight={true}
                onEnter={onEnterBuscar}
                enterStr={"Avanzar"}
                onChange={onChangeTeclado}
                maxLength={maxLength}
                onDelete={onDeleteTeclado}
              />
            )}
          </BuscadorEstudioTecladoContainer>
        </BuscadorEstudioFooter>
      </BuscadorEstudioContainer>
    </>
  );
};

export default BuscadorTurnoEstudio;
